import {
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_LOADING,
  USER_LOGIN_RESET,
  USER_LOGIN_ERROR_RESET,
  USER_TOKEN_REFRESH_SUCCESS,
  GET_PROFILE_DATA_SUCCESS,
  GET_CURRENT_GOAL_DATA_SUCCESS,
} from '../actions/actionTypes'

const initialState = {
  accessToken: '',
  refreshToken: '',
  loading: false,
  error: '',
}

const user = (state = localStorageSync.syncInit(initialState), action) => {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
      localStorageSync.save(action.data)
      return { ...state, ...action.data, loading: false }
    case GET_PROFILE_DATA_SUCCESS:
    case GET_CURRENT_GOAL_DATA_SUCCESS:
      localStorageSync.save({ ...state, ...action.data })
      return { ...state, ...action.data, loading: false }

    case USER_LOGIN_LOADING:
      return { ...state, loading: true }

    case USER_LOGIN_FAIL:
      localStorageSync.reset()
      return { ...state, error: action.error, loading: false }

    case USER_LOGIN_RESET:
      localStorageSync.reset()
      return { ...initialState }

    case USER_LOGIN_ERROR_RESET:
      return { ...state, error: '' }

    case USER_TOKEN_REFRESH_SUCCESS:
      localStorageSync.save({ ...state, ...action.data })
      return { ...state, ...action.data }

    default:
      return state
  }
}

export default user

const LOCAL_STORAGE_KEY = 'se_cabinet_user'

const localStorageSync = {
  save: data => localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data)),
  reset: () => localStorage.removeItem(LOCAL_STORAGE_KEY),
  syncInit: initialState => {
    const storedData = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (!storedData) return initialState

    const parsedStoredData = JSON.parse(storedData)
    return { ...initialState, ...parsedStoredData }
  },
}
